import React, { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { getRouteStackPath } from '@portal/config/routes';
import PanelContent from '~/components/PanelContent/PanelContent';

import Pix from './Pix';
import NewKeyPix from './NewKeyPix/NewKeyPix';
import PayPix from './PayPix/PayPix';
import { translate } from '@portal/services/i18n';
import Transfer from './Transfer/Transfer';
import PixLimit from './PixLimit/PixLimit';
import { PageClass } from '@portal/enum/analytics';
import { sendEvent } from '@portal/services/firebase';
import PixWithdrawAndChange from './PixWithdrawAndChange/PixWithdrawAndChange';
import { pix, availableSoon } from '@portal/config/app.json';
import NotFound from '@portal/pages/NotFound/NotFound';

const PixNavigationStack = () => {
  const location = useLocation();

  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.PIX,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <Switch>
      <Route exact path={getRouteStackPath('PIX', 'PIX')}>
        <PanelContent
          pageTitle={translate('PAGES.HOME.PIX.PAGE_TITLE')}
          pageDescription={translate('PAGES.HOME.PIX.PAGE_DESCRIPTION')}
        >
          <Pix />
        </PanelContent>
      </Route>
      {pix.enabled && !availableSoon.pix ? (
        <>
          <Route exact path={getRouteStackPath('PIX', 'KEYS')}>
            <PanelContent pageTitle={translate('PAGES.HOME.PIX.PAGE_TITLE')}>
              <NewKeyPix />
            </PanelContent>
          </Route>
          <Route exact path={getRouteStackPath('PIX', 'COPY_PASTE')}>
            <PanelContent
              pageTitle={translate('COMPONENTS.PAY_PIX.PAGE_TITLE')}
            >
              <PayPix />
            </PanelContent>
          </Route>
          {pix.pixWithdrawAndChange ? (
            <Route exact path={getRouteStackPath('PIX', 'WITHDRAW_AND_CHANGE')}>
              <PanelContent
                pageTitle={translate('COMPONENTS.PAY_PIX.PAGE_TITLE')}
              >
                <PixWithdrawAndChange />
              </PanelContent>
            </Route>
          ) : null}
          <Route exact path={getRouteStackPath('PIX', 'TRANSFER')}>
            <PanelContent
              pageTitle={translate('PAGES.HOME.PIX.BUTTONS.TRANSFER')}
            >
              <Transfer />
            </PanelContent>
          </Route>
          <Route exact path={getRouteStackPath('PIX', 'LIMIT')}>
            <PanelContent
              pageTitle={translate('PAGES.HOME.PIX.PIX_LIMIT.TITLE')}
            >
              <PixLimit />
            </PanelContent>
          </Route>
        </>
      ) : null}
      <Route>
        <NotFound />
      </Route>
    </Switch>
  );
};

export default PixNavigationStack;
